export default "__VITE_ASSET__F0zJfKZE__"